var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h1", [_vm._v(_vm._s(_vm.$t("delegationTask.title")))]),
      _c("delegation-info-menu"),
      _c(
        "v-row",
        { staticStyle: { "margin-bottom": "15px" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "3" } },
            [
              _c("v-text-field", {
                attrs: {
                  "append-icon": "search",
                  label: _vm.$t("global.search"),
                  "single-line": "",
                  "hide-details": ""
                },
                model: {
                  value: _vm.search,
                  callback: function($$v) {
                    _vm.search = $$v
                  },
                  expression: "search"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("v-data-table", {
        attrs: {
          headers: _vm.headers,
          items: _vm.delegationTask,
          "footer-props": {
            "items-per-page-options": [
              { text: "$vuetify.dataIterator.rowsPerPageAll", value: -1 }
            ]
          },
          search: _vm.search,
          "hide-default-footer": ""
        },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function(props) {
              return [
                _c("tr", [
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(" " + _vm._s(props.item.list_order) + " ")
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(" " + _vm._s(_vm.getName(props.item)) + " ")
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    props.item.is_comment_required === 1
                      ? _c("span", [_vm._v(_vm._s(_vm.$t("global.yes")))])
                      : _vm._e(),
                    props.item.is_comment_required === 0
                      ? _c("span", [_vm._v(_vm._s(_vm.$t("global.no")))])
                      : _vm._e()
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    props.item.is_enabled === 1
                      ? _c("span", [_vm._v(_vm._s(_vm.$t("global.yes")))])
                      : _vm._e(),
                    props.item.is_enabled === 0
                      ? _c("span", [_vm._v(_vm._s(_vm.$t("global.no")))])
                      : _vm._e()
                  ]),
                  _c(
                    "td",
                    {
                      staticClass: " justify-center align-content-center px-0"
                    },
                    [
                      props.item.used_in_delegations > 0
                        ? _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "delegationTask.taskEditAppliesNTimes",
                                  props.item.used_in_delegations,
                                  { count: props.item.used_in_delegations }
                                )
                              ) + " "
                            ),
                            _c("br")
                          ])
                        : _vm._e(),
                      props.item.used_in_delegations === 0
                        ? _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("delegationTask.taskZeroTimes"))
                            ),
                            _c("br")
                          ])
                        : _vm._e(),
                      props.item.is_system_value > 0
                        ? _c("span", [
                            _vm._v(_vm._s(_vm.$t("delegationTask.systemItem")))
                          ])
                        : _vm._e()
                    ]
                  )
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }